module.exports = __webpack_public_path__ + "img/Edit3.2e055f26.svg";